import { render, staticRenderFns } from "./BaseKpiStatCard.vue?vue&type=template&id=10477513"
import script from "./BaseKpiStatCard.vue?vue&type=script&lang=js"
export * from "./BaseKpiStatCard.vue?vue&type=script&lang=js"
import style0 from "./BaseKpiStatCard.vue?vue&type=style&index=0&id=10477513&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports